import { Link } from 'react-router-dom'
import ScrollReveal from '@/components/base/ScrollReveal'

export default function StatsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" aria-labelledby="stats-title">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">

          <div className="w-full lg:w-[45%] space-y-6">
            <ScrollReveal direction="up" delay={0} duration={550}>
              <h2 id="stats-title" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                关于韩漫漫画网站
              </h2>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={100} duration={550}>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
                韩漫漫画网站致力于为中国读者提供正版、高清、极速的韩国漫画阅读体验。我们与韩国多家顶级漫画平台建立了深度合作关系，拥有超过一万部签约作品的官方授权。专业的翻译团队确保每部作品的翻译质量，让中国读者能够第一时间享受到原汁原味的韩漫内容。
              </p>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={200} duration={450}>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 hover:-translate-y-0.5 hover:shadow-[0_4px_20px_-4px_oklch(var(--secondary-500)/0.4)] active:translate-y-0 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={300} duration={500}>
              <div className="flex items-center gap-12 pt-4">
                <div>
                  <p className="font-heading text-3xl md:text-4xl font-black text-foreground-950">10,000+</p>
                  <p className="text-xs text-foreground-500 mt-1">部签约作品</p>
                </div>
                <div>
                  <p className="font-heading text-3xl md:text-4xl font-black text-foreground-950">500万</p>
                  <p className="text-xs text-foreground-500 mt-1">日活读者</p>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <ScrollReveal direction="right" delay={200} duration={650} className="w-full lg:w-[55%]">
            <div className="relative rounded-3xl overflow-hidden group" style={{ height: '380px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20studio%20workspace%2C%20creative%20artists%20working%20on%20digital%20tablets%2C%20warm%20lighting%2C%20modern%20creative%20office%20interior%2C%20webtoon%20production%20environment%2C%20clean%20aesthetic%2C%20soft%20natural%20light%2C%20wooden%20furniture%2C%20creative%20atmosphere%2C%20editorial%20photography%20style&width=1200&height=760&seq=studio-scene-01&orientation=landscape"
                alt="韩漫创作工作室"
                className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700 ease-out"
                loading="lazy"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-3 py-1.5 bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full">
                  📍 首尔 · 弘大
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/60 to-transparent p-6">
                <div className="flex items-center gap-4">
                  <span className="text-sm font-semibold text-background-50">正版授权</span>
                  <span className="w-1 h-1 rounded-full bg-background-50/60"></span>
                  <span className="text-sm font-semibold text-background-50">每日更新</span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}